import React from 'react';
import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://zborovska.com';
const OG_IMAGE = 'https://zborovska.com/og-image.jpg';

/**
 * SEO component - per-page meta tags for Prague photographer focus
 */
const SEO = ({
  title,
  description,
  path = '/',
  image = OG_IMAGE,
  noIndex = false,
}) => {
  const fullUrl = `${BASE_URL}${path}`;
  const fullTitle = title ? `${title} | Marta Zborovska Photography Prague` : 'Marta Zborovska | Prague Photographer & Videographer';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
